function EMAOnDemandCheckin() {
    "use strict";

    this.__type = 'EMAOnDemandNotification:www.veritracks.com';
    this.Id = "";
    this.AppUserId = "";
    this.AgentId = -1;
    this.IsVideoCall = -1;
    this.AgentName = "";
}
if (typeof exports !== 'undefined') {
    module.exports = EMAOnDemandCheckin;
}